import { EyeIcon } from "@heroicons/react/24/outline";
import { Button, Card, CardBody, CardHeader, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner, TableCell, TableRow, useDisclosure } from "@nextui-org/react";
import { month } from "../../../../../services/enum";
import { useState } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../../../services/api";
import ClientTablePagination from "../../../../elements/ClientTablePagination";

export default function ModalDetailDistribution({ id }) {
    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const [detailId, setDetailId] = useState(null);
    const { data: dataDetail, isLoading: isLoadingDetail } = useSWR(detailId ? `/api/pelaporan-bahan-b3-distribusi/find/${detailId}` : null, getFetcher);
    const headerCustomer = ['Nama Perusahaan', 'Alamat Kantor', 'Jumlah Distribusi']
    const headerTransporter = ['Nama Perusahaan', 'Alamat Kantor']

    const contentCustomer = (item) => (
        <TableRow key={item?.dataCustomer?.id}>
            <TableCell>{item?.dataCustomer?.namaCustomer}</TableCell>
            <TableCell>{item?.dataCustomer?.alamat}</TableCell>
            <TableCell>{item?.jumlahBahanB3Distribusi} Kg</TableCell>
        </TableRow>
    )

    const contentTransporter = (item) => (
        <TableRow key={item?.dataTransporter?.id}>
            <TableCell>{item?.dataTransporter?.namaTransPorter}</TableCell>
            <TableCell>{item?.dataTransporter?.alamat}</TableCell>
        </TableRow>
    )

    function onOpenModal(id) {
        setDetailId(id);
        onOpen();
    }

    return (
        <>
            <Button isIconOnly size="sm" color="primary" onPress={() => onOpenModal(id)}><EyeIcon className="size-4" /></Button>
            <Modal scrollBehavior="inside" size="3xl" isOpen={isOpen} onOpenChange={onOpenChange}>
                <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">Detail Laporan Distribusi</ModalHeader>
                        <ModalBody>
                            {
                                isLoadingDetail
                                ?
                                <div className="flex flex-col items-center justify-center">
                                    <Spinner />
                                </div>
                                :
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Perusahaan</span>
                                        <span className='text-sm font-medium'>{dataDetail?.company?.name}</span>
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Periode</span>
                                        <span className='text-sm font-medium'>{dataDetail?.period?.name}</span>
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Bulan</span>
                                        <span className='text-sm font-medium'>{month[dataDetail?.bulan-1]}</span>
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Tahun</span>
                                        <span className='text-sm font-medium'>{dataDetail?.tahun}</span>
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Jenis B3</span>
                                        <span className='text-sm font-medium'>{dataDetail?.dataBahanB3?.namaBahanKimia ?? '-'}</span>
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-xs text-ink-400 uppercase'>Total Distribusi B3</span>
                                        <span className='text-sm font-medium'>{dataDetail?.jumlahB3Distribusi} Kg</span>
                                    </div>
                                    <div className="col-span-2">
                                        <Card radius="sm">
                                            <CardHeader>
                                                <span className='text-xs text-ink-400 uppercase'>Data Perusahaan Transporter</span>
                                            </CardHeader>
                                            <CardBody>
                                                <ClientTablePagination 
                                                    header={headerTransporter} 
                                                    content={contentTransporter} 
                                                    data={dataDetail?.DataTransporterOnPelaporanDistribusiBahanB3} 
                                                />
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className="col-span-2">
                                        <Card radius="sm">
                                            <CardHeader>
                                                <span className='text-xs text-ink-400 uppercase'>Data Perusahaan Customer</span>
                                            </CardHeader>
                                            <CardBody>
                                                <ClientTablePagination 
                                                    header={headerCustomer} 
                                                    content={contentCustomer} 
                                                    data={dataDetail?.DataCustomerOnPelaporanDistribusiBahanB3} 
                                                />
                                            </CardBody>
                                        </Card>        
                                    </div> 
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" variant="light" onPress={onClose}>
                                Tutup
                            </Button>
                        </ModalFooter>
                    </>
                )}
                </ModalContent>
            </Modal>
        </>
    )
}
